import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { LWApiPublicBillingPaymentInstrumentAllowedResultRaw } from '@liquidweb-dev/club-sauce/public/billing/payment/instrument/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';

import api from 'modules/queries/api';

export const BILLING_PAYMENT_INSTRUMENT_ALLOWED_QUERY_KEY =
	'/billing/payment/instrument/allowed';

/**
 * The `type`/`processor` pairs a **new** payment instrument may be created as.
 *
 * This governs creation only. An instrument already on file for a pair that is
 * no longer listed keeps working, so never use this to filter `list`.
 */
const useBillingPaymentInstrumentAllowed = (
	options?: UseQueryOptions<
		LWApiPublicBillingPaymentInstrumentAllowedResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [BILLING_PAYMENT_INSTRUMENT_ALLOWED_QUERY_KEY],
		queryFn: () => api.billing.payment.instrument.apiRaw.allowed({}),
		...options,
	});

export default useBillingPaymentInstrumentAllowed;
